<template>
  <div class='hs-pagination'>
    <el-pagination v-on='$listeners' v-bind='attrs'></el-pagination>
  </div>
</template>

<script>
export default {
  name:'HsPagination',
  props: {
    elProps:{
      type:Object,
      default(){
        return {}
      }
    }
  },
  data() {
    return {
      attrs:{}
    }
  },
  created () {
    this.attrs={
      background:true,
      layout:'total,prev,pager,next,sizes,jumper',
      ...this.elProps
    };
  },
}
</script>

<style lang="scss" scoped>

</style>